export function useScrollReveal(options?: { threshold?: number }) {
  const elementReference = ref<HTMLElement | null>(null)
  const isReady = ref(false)
  const isRevealed = ref(false)
  let observer: IntersectionObserver | null = null
  let timeoutId: ReturnType<typeof setTimeout> | null = null

  onMounted(() => {
    isReady.value = true

    if (!elementReference.value) return

    observer = new IntersectionObserver(
      entries => {
        if (!entries[0]?.isIntersecting) {
          return
        }

        isRevealed.value = true
        observer?.disconnect()
        if (timeoutId) clearTimeout(timeoutId)
      },
      { threshold: options?.threshold ?? 0.15 }
    )
    observer.observe(elementReference.value)

    timeoutId = setTimeout(() => {
      if (isRevealed.value) {
        return
      }

      isRevealed.value = true
      observer?.disconnect()
    }, 2000)
  })

  onUnmounted(() => {
    observer?.disconnect()
    if (timeoutId) clearTimeout(timeoutId)
  })

  return { elementReference, isReady, isRevealed }
}
